import React, { useCallback, useRef } from 'react';
import AnalyticsPanel from './AnalyticsPanel';
import AnalyticsNivoFrame from './AnalyticsNivoFrame';
import { ChartPanelExport } from '../chartShare';
import {
  buildResponsiveFillFlex,
  buildResponsiveFillHeight,
  buildResponsiveFillMaxHeight,
} from './workspaceResponsiveSizing';

function AnalyticsChartPanel({
  allowAxisOverflow = false,
  children,
  exportConfig,
  exportEnabled = true,
  frame = true,
  frameSx,
  minFrameHeight,
  contentSx,
  fill = true,
  variant = 'chart',
  ...panelProps
}) {
  const chartFrameRef = useRef(null);
  const renderExportChart = useCallback(() => children, [children]);
  const hasDomainExportRenderer = Boolean(exportConfig && typeof exportConfig.renderChart === 'function');
  const hasDomainExportControls = Boolean(exportConfig && typeof exportConfig.renderChartControls === 'function');
  const resolvedExportConfig = exportConfig && typeof exportConfig === 'object'
    ? hasDomainExportRenderer && hasDomainExportControls
      ? { mode: 'interactive', ...exportConfig }
      : { mode: 'interactive', interactiveControls: 'auto', ...exportConfig }
    : exportConfig === undefined
      ? { mode: 'interactive', interactiveControls: 'auto' }
      : exportConfig;
  const exportAvailable = (frame || hasDomainExportRenderer)
    && exportConfig !== false
    && Boolean(panelProps.title);
  const resolvedActions = exportAvailable ? (
    <>
      {panelProps.actions}
      <ChartPanelExport
        frameRef={chartFrameRef}
        title={panelProps.title}
        description={panelProps.description}
        enabled={exportEnabled}
        exportConfig={resolvedExportConfig}
        renderChart={renderExportChart}
        chartNode={children}
      />
    </>
  ) : panelProps.actions;

  return (
    <AnalyticsPanel
      {...panelProps}
      actions={resolvedActions}
      variant={variant}
      fill={fill}
      contentSx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: buildResponsiveFillHeight(fill),
        maxHeight: buildResponsiveFillMaxHeight(fill),
        flex: buildResponsiveFillFlex(fill),
        ...contentSx,
        overflow: 'hidden',
      }}
    >
      {frame ? (
        <AnalyticsNivoFrame
          allowAxisOverflow={allowAxisOverflow}
          frameRef={chartFrameRef}
          minHeight={minFrameHeight}
          sx={frameSx}
        >
          {children}
        </AnalyticsNivoFrame>
      ) : children}
    </AnalyticsPanel>
  );
}

export default AnalyticsChartPanel;
